$(function() {

    const $questions = $('.form-section');
    if (!$questions.length) {
        return;
    }
    //フォームサブミット時のバリデーション
    $('#qustion_form').on('submit', function() {
        let types =[];
        let can_go = 1;
        $.each($questions, function(key, question) {
            if($(question).data('is_required')) {
                let type_id = parseInt($(question).data('type_id'))
                let question_id = $(question).data('question_id');
                let validated = 0;
                switch(type_id) {
                    case 1:
                        validated = checkRadio(question_id);
                        break;
                    case 2:
                        validated = checkCheckBox(question_id);
                        break;
                    case 3:
                        validated = checkSelect(question_id);
                        break;
                    case 6:
                        validated = checkTextarea(question_id);
                        break;
                    default:
                        return;
                }
                if (!validated) {
                    can_go = 0;
                }
            }
        });
        if (!can_go) {
            return false;
        }
    });

    function checkRadio(question_id) {
        let $this = $('div[data-question_id="' + question_id + '"]');
        let inputs = $this.find('input');
        let is_checked = 0;
        $.each(inputs, function(key, input) {
            if ($(input).prop('checked') == true) {
                is_checked++;
                $('#question_' + question_id).tooltip('hide');
                return false;
            }
        })
        if (!is_checked) {
            $('#question_' + question_id).tooltip('show');
            setTimeout(function() {
                $('#question_' + question_id).tooltip('hide');
            }, 1500);
        }
        let textarea = $this.find('textarea');
        if (textarea.length) {
            is_checked = checkExtraTextarea(textarea, is_checked);
        }

        return is_checked;
    }

    function checkCheckBox(question_id) {
        let $this = $('div[data-question_id="' + question_id + '"]');
        let inputs = $this.find('input');
        let is_checked = 0;
        $.each(inputs, function(key, input) {
            if ($(input).prop('checked') == true) {
                is_checked++;
                $('#question_' + question_id).tooltip('hide');
            }
        })
        if (!is_checked) {
            $('#question_' + question_id).tooltip('show');
            setTimeout(function() {
                $('#question_' + question_id).tooltip('hide');
            }, 1500);
        }
        let textarea = $this.find('textarea');
        if (textarea.length) {
            is_checked = checkExtraTextarea(textarea, is_checked);
        }

        return is_checked;
    }

    /**
     * ラジオボタンとチェックボックスの共通メソッド
     * テキストエリアの同じ階層にラジオボタン/チェックボックスがあった場合、
     * チェックが入っていたらテキストエリアを必須にする。
     * @param {*} textarea
     * @param {*} is_checked
     * @returns
     */
    function checkExtraTextarea(textarea, is_checked) {
        if($(textarea[0]).val().length == 0) {
            $(textarea[0]).tooltip('hide');
            let parent_checkbox = $(textarea[0]).parent().find('input').first();
            if(parent_checkbox.prop('checked') == true) {
                $(textarea[0]).tooltip('show');
                is_checked =  0;
                setTimeout(function() {
                    $(textarea[0]).tooltip('hide');
                }, 1500);
            }
        }
        return is_checked;
    }

    function checkSelect(question_id) {
        let $this = $('div[data-question_id="' + question_id + '"]');
        let selects = $this.find('select');
        let is_selected = 0;
        $.each(selects, function(key, select) {
            if ($(select).val()) {
                is_selected++;
                $(select).tooltip('hide');
                return true;
            } else {
                $(select).tooltip('show');
                setTimeout(function() {
                    $(select).tooltip('hide');
                }, 1500);
            }

        })
        return selects.length == is_selected;
    }

    function checkTextarea(question_id) {
        let $this = $('#textarea_' + question_id);
        $this.tooltip('hide');
        if ($this.val().length == 0) {
            $this.tooltip('show');
            setTimeout(function() {
                $this.tooltip('hide');
            }, 1500);
            return false;
        }
        return true;
    }
});
